// login action types

export const API_REQUEST = "API_REQUEST";

export const API_SUCCESS = "API_SUCCESS";

export const API_ERROR = "API_ERROR";

export const CANCEL_API_REQUEST = "CANCEL_API_REQUEST";

//User action types
export const USER_API_REQUEST = "USER_API_REQUEST";

export const USER_API_SUCCESS = "USER_API_SUCCESS";

export const USER_API_ERROR = "USER_API_ERROR";

export const USER_CANCEL_API_REQUEST = "USER_CANCEL_API_REQUEST";


// action creators for login

export const apiRequest = ({ url, method, data, headers, auth }) => {

  return {

    type: API_REQUEST,

    meta: { url, method, data, headers, auth }

  };

};


export const cancelApiRequest = () => {

  return {

    type: CANCEL_API_REQUEST

  };
 
};


export const apiSuccess = ({ response }) => ({

  type: API_SUCCESS,

  payload: response

});


export const apiError = ({ error }) => ({

  type: API_ERROR,

  payload: error

});


// USER API's 

export const userApiRequest = ({ url, method, data, headers, auth }) => {

  return {

    type: USER_API_REQUEST,

    meta: { url, method, data, headers, auth }

  };

};


export const userCancelApiRequest = () => {

  return {

    type: USER_CANCEL_API_REQUEST

  };
 
};


export const userApiSuccess = ({ response }) => ({

  type: USER_API_SUCCESS,

  payload: response

});


export const userApiError = ({ error }) => ({

  type: USER_API_ERROR,

  payload: error

});

// 